"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconMenu2 = function IconMenu2(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16",
    height: "16",
    className: (0, _classnames.default)('Icon', 'IconMenu2', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("g", {
    id: "menu-2",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "Mask"
  }, _react.default.createElement("path", {
    d: "M2,1.5 C1.72385763,1.5 1.5,1.72385763 1.5,2 L1.5,14 C1.5,14.2761424 1.72385763,14.5 2,14.5 L14,14.5 C14.2761424,14.5 14.5,14.2761424 14.5,14 L14.5,2 C14.5,1.72385763 14.2761424,1.5 14,1.5 L2,1.5 Z M2,0 L14,0 C15.1045695,-2.02906125e-16 16,0.8954305 16,2 L16,14 C16,15.1045695 15.1045695,16 14,16 L2,16 C0.8954305,16 1.3527075e-16,15.1045695 0,14 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Rectangle",
    fillRule: "nonzero"
  }), _react.default.createElement("g", {
    id: "menu",
    transform: "translate(4.000000, 4.000000)"
  }, _react.default.createElement("g", {
    transform: "translate(0.250000, 0.875000)",
    id: "Path"
  }, _react.default.createElement("path", {
    d: "M7.08352942,1.2 L0.416911768,1.2 C0.186617651,1.2 0,0.931286395 0,0.600317627 C0,0.268713605 0.186617651,0 0.416911768,0 L7.08352942,0 C7.31338235,0 7.5,0.268713605 7.5,0.600317627 C7.5,0.931286395 7.31338235,1.2 7.08352942,1.2"
  }), _react.default.createElement("path", {
    d: "M7.08352942,3.86523059 L0.416911768,3.86523059 C0.186617651,3.86523059 0,3.59651697 0,3.26554821 C0,2.93394421 0.186617651,2.66523059 0.416911768,2.66523059 L7.08352942,2.66523059 C7.31338235,2.66523059 7.5,2.93394421 7.5,3.26554821 C7.5,3.59651697 7.31338235,3.86523059 7.08352942,3.86523059"
  }), _react.default.createElement("path", {
    d: "M7.08352942,6.53046116 L0.416911768,6.53046116 C0.186617651,6.53046116 0,6.2617476 0,5.93077878 C0,5.59917478 0.186617651,5.33046116 0.416911768,5.33046116 L7.08352942,5.33046116 C7.31338235,5.33046116 7.5,5.59917478 7.5,5.93077878 C7.5,6.2617476 7.31338235,6.53046116 7.08352942,6.53046116"
  }))))));
};

var _default = IconMenu2;
exports.default = _default;